import React, {
    useEffect,
} from "react";

import {
    Box,
    Flex,
    Text,
} from "@chakra-ui/react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import ReusableTable from
    "components/Tables/ReusableTable";

import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";

import {
    fetchDriverPartnerPayoutsAction,
} from "state/actions/driverPartnerPayoutActions";

import { formatDate }
    from "utils/dateFormatter";

const PayoutHistory = () => {
    const dispatch =
        useDispatch();

    const {
        payouts,
        pagination,
        loading,
    } = useSelector(
        (state) =>
            state.driverPartnerPayouts
    );

    const {
        driverPartners,
    } = useSelector(
        (state) =>
            state.driverPartners
    );

    useEffect(() => {
        dispatch(
            fetchDriverPartnerPayoutsAction()
        );
    }, [dispatch]);

    const columnsData = [
        {
            Header:
                "Driver Partner",

            accessor: (
                row
            ) => {
                const partner =
                    driverPartners.find(
                        (
                            p
                        ) =>
                            p
                                .driver_partner
                                ?.driver_partner_id ===
                            row.partner_id
                    );

                return `${partner?.user?.first_name || ""} ${
                    partner?.user
                        ?.last_name ||
                    ""
                }`.trim() ||
                    partner
                        ?.user
                        ?.username ||
                    "Unknown";
            },
        },

        {
            Header:
                "Amount",

            accessor:
                "amount",

            Cell: ({
                value,
            }) => (
                <Text
                    fontWeight="700"
                    color="#071D54"
                >
                    P
                    {
                        value
                    }
                </Text>
            ),
        },

        {
            Header:
                "Payment Method",

            accessor:
                "payment_method",
        },

        {
            Header:
                "Reference",

            accessor:
                "payment_reference",
        },

        {
            Header:
                "Period",

            accessor:
                "payout_period",
        },

        {
            Header:
                "Paid At",

            accessor:
                "paid_at",

            Cell: ({
                value,
            }) =>
                value
                    ? formatDate(
                          value
                      )
                    : "-",
        },

        {
            Header:
                "Status",

            accessor:
                "status",

            Cell: ({
                value,
            }) => (
                <StatusBadge
                    label={
                        value
                    }
                    variant={getStatusVariant(
                        value
                    )}
                />
            ),
        },
    ];

    return (
        <Box>
            <Flex
                justify="space-between"
                align="center"
                mb={4}
                pt={{
                    base: "120px",
                    md: "25px",
                }}
            >
                {loading ? (
                    <Skeleton
                        width="220px"
                    />
                ) : (
                    <Text
                        fontWeight="700"
                        fontSize="lg"
                    >
                        Payout
                        History:
                        {" "}
                        {
                            pagination.total
                        }
                    </Text>
                )}
            </Flex>

            <ReusableTable
                columnsData={
                    columnsData
                }
                tableData={
                    payouts
                }
                isLoading={
                    loading
                }
            />
        </Box>
    );
};

export default PayoutHistory;